import React from "react";
import { Link } from "react-router-dom";

import blogs from "../../api/blogs";

import blogIcon01 from "../../images/icon/blog-icon01.svg";
import blogIcon02 from "../../images/icon/blog-icon02.svg";

interface RelatedBlogProps {
  currentSlug: string;
}

const RelatedBlog: React.FC<RelatedBlogProps> = ({ currentSlug }) => {
  const relatedPosts = blogs
    .filter((post) => post.slug !== currentSlug)
    .slice(0, 3);

  return (
    <div className="related-blog pt-130">
      <h2 className="related-blog-title">Related posts</h2>

      <div className="row mt-none-30">
        {relatedPosts.map((post) => (
          <div className="col-lg-4 col-md-6 mt-30" key={post.id}>
            <div className="xb-blog-item xb-small-blog-item">
              <div className="xb-item--inner img-hove-effect xb-border">
                <div className="xb-img">
                  {[1, 2, 3, 4].map((n) => (
                    <Link key={n} to={`/blog/${post.slug}`}>
                      <img src={post.image} alt={post.title} />
                    </Link>
                  ))}
                </div>

                <div className="xb-item--holder">
                  <ul className="xb-item--meta list-unstyled ul_li">
                    <li>
                      <img src={blogIcon01} alt="icon" />
                      {post.tag}
                    </li>
                    <li>
                      <img src={blogIcon02} alt="icon" />
                      {post.date}
                    </li>
                  </ul>

                  <h2 className="xb-item--title border-effect-2">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedBlog;
